import {instance} from ".";

export const getRoomsList = () => {
  return instance({
    method: "get",
    url: "/work/api/room"
  });
};

export const getRoomCard = id => {
  return instance({
    method: "get",
    url: `/work/api/room/${id}/card`
  });
};

export const getRoomFullInfo = id => {
  return instance({
    method: "get",
    url: `/work/api/room/${id}`
  });
};

export const getRoomTypes = () => {
  return instance({
    method: "get",
    url: "/work/api/dict/room-type"
  });
};

export const getRoomSpecialities = id => {
  return instance({
    method: "get",
    url: `/work/api/room/${id}/main/speciality`
  });
};

export const getRoomWorldSkills = id => {
  return instance({
    method: "get",
    url: `/work/api/room/${id}/main/world-skill`
  });
};

export const getSpecialities = () => {
  return instance({
    method: "get",
    url: `/work/api/dict/speciality`
  });
};

export const getWorldSkills = () => {
  return instance({
    method: "get",
    url: `/work/api/dict/world-skill`
  });
};

export const getRoomPhotos = (id) => {
  return instance({
    method: "get",
    url: `/work/api/room/${id}/main/photo`
  });
};

export const getResourceTypes = () => {
  return instance({
    method: "get",
    url: `/work/api/dict/resource-type`
  });
};

export const getInventory = id => {
  return instance({
    method: "get",
    url: `/work/api/room/${id}/resource`
  });
};

export const getUnitTypes = () => {
  return instance({
    method: "get",
    url: `/work/api/dict/unit`
  });
};

export const getInventoryItem = (id) => {
  return instance({
    method: "get",
    url: `/work/api/resource/${id}`,
  });
};

export const createInventoryItem = (data) => {
  return instance({
    method: "post",
    url: `/work/api/resource/`,
    data
  });
};

export const deleteInventoryItem = id => {
  return instance({
    method: "delete",
    url: `/work/api/resource/${id}`
  });
};

export const createRoom = data => {
  return instance({
    method: "post",
    url: `/work/api/room/`,
    data
  });
};

export const updateRoom = (id, info) => {
  const { specialities, worldSkills, ...main } = info.data;
  return instance({
    method: "put",
    url: `/work/api/room/${id}`,
    data: {
      main,
      specialities: specialities.map(i => i.id),
      worldSkills: worldSkills.map(i => i.id)
    }
  });
};

export const addRoomPhoto = (id, images) => {
  const data = new FormData();
  data.set('photo', images);

  return instance({
    method: "post",
    url: `/work/api/room/${id}/main/photo/`,
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data,
  });
}

export const deleteRoomPhoto = (fileId, roomId) => {
  return instance({
    method: "delete",
    url: `/work/api/room/${roomId}/main/photo/${fileId}`
  });
};

export const deleteRoom = id => {
  return instance({
    method: "delete",
    url: `/work/api/room/${id}`
  });
};

export default {
  getRoomsList,
  getRoomCard,
  getRoomTypes,
  getSpecialities,
  getRoomPhotos,
  getWorldSkills,
  getInventory,
  getUnitTypes,
  getInventoryItem,
  deleteInventoryItem,
  createInventoryItem,
  getRoomSpecialities,
  getRoomWorldSkills,
  getRoomFullInfo,
  getResourceTypes,
  createRoom,
  updateRoom,
  deleteRoom,
  addRoomPhoto,
  deleteRoomPhoto
};
